module.exports = __webpack_public_path__ + "static/media/Philatelist-Gabriel-stamp-view_2.de0db82e.jpg";